import { createFileRoute } from "@tanstack/react-router";
import { Reading } from "../../app/views/readingFC";

export const Route = createFileRoute("/feed/read")({
  component: Reading,
});
